/* eslint-disable import/no-anonymous-default-export */
import coreApi from "../../lib/coreApi";

export default {
  onBoardEmployeeInfo: ({ cid, eid }) => {
    let url = `/onboarding/${cid}/employees/${eid}`;
    let result = coreApi.GET(url);
    return result;
  },
  onBoardEmployeeVerify: ({ cid, eid, data }) => {
    let url = `/onboarding/${cid}/employees/${eid}`;
    let result = coreApi.PUT(url, data);
    return result;
  },
  onBoardEmployeeVerifyGovtData: ({ cid, eid, data }) => {
    let url = `/onboarding/${cid}/verify/${eid}`;
    let result = coreApi.PUT(url, data);
    return result;
  },
  onBoardEmployeeTerms: ({ cid, eid, data }) => {
    let url = `/onboarding/${cid}/employees/${eid}/terms-and-conditions`;
    let result = coreApi.POST(url, data);
    return result;
  },
  getDeductionList: () => {
    const user = JSON.parse(localStorage.user)
    let url = `${user.is_hr ? '/hr/deductions' : '/admin/deductions'}`;
    let result = coreApi.GET(url);
    return result;
  },
};
